import { JmkwEvent } from '@jeppesen-foreflight/jmkw-types';
import { NavigationLayer } from './layer/navigation.layer';
import { ManualFeatureSelectionProperties } from './selected-item/typings/manual-feature-selection-properties';
import { IFR_TOGGLE_BUTTON } from './ifr.plugin';
import { IFR } from './typings/ifr';

export class NavigationLayerReadyEvent extends JmkwEvent {
  constructor() {
    super('nav-layer-ready', new CustomEvent('nav-layer-ready'));
  }
}

export class SetExplicitIFREvent extends JmkwEvent {
  constructor(config: IFR) {
    super(
      'set-explicit-ifr',
      new CustomEvent('set-explicit-ifr', { detail: config })
    );
  }
}

export class IFRToggleEvent extends JmkwEvent {
  constructor(layer: NavigationLayer) {
    super(
      'ifr-toggle',
      new CustomEvent('ifr-toggle', { detail: layer.ifr }),
      IFR_TOGGLE_BUTTON
    );
  }
}

export class ManualFeatureSelectionEvent extends JmkwEvent {
  constructor(selection: ManualFeatureSelectionProperties) {
    super(
      'manual-feature-selection',
      new CustomEvent('manual-feature-selection'),
      selection
    );
  }
}
